// extracted by mini-css-extract-plugin
module.exports = {"container":"_2VG507gDqcHGve4LcxE4pY","article":"KYHt5uWQg7zN6fX7tfXHQ"};